import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "page-main",
  style: {
    "display": "flex",
    "height": "calc(100vh - 120px)"
  }
};
const _hoisted_2 = {
  style: {
    "display": "inherit",
    "flex-direction": "column",
    "width": "calc(100vw - 340px)",
    "background": "#FFF"
  }
};
const _hoisted_3 = {
  class: "tabs"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "op-content",
  style: {
    "flex": "1",
    "max-height": "calc(100vh - 160px)"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "cascader-box"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  key: 0,
  class: "btns"
};
const _hoisted_9 = ["src", "onClick"];
const _hoisted_10 = ["src", "onClick"];
const _hoisted_11 = ["src", "onClick"];
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_cascader_panel = _resolveComponent("el-cascader-panel");
  const _component_position_detail = _resolveComponent("position-detail");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.positionTopNode, i => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab", {
        'active': i.id === _ctx.activeTab
      }]),
      key: i.id,
      onClick: $event => $setup.clickTab(i)
    }, _toDisplayString(i.nodeName), 11, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [$setup.positionData.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_cascader_panel, {
    props: $setup.options,
    options: $setup.positionData,
    onChange: $setup.changeNode
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("span", {
      title: data.nodeName
    }, _toDisplayString(data.nodeName), 9, _hoisted_7), _ctx.activeTab != '001' ? (_openBlock(), _createElementBlock("span", _hoisted_8, [data.positionType === 1 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: require('@/assets/icons/add.svg'),
      onClick: _withModifiers($event => $setup.addHandler(data), ["stop"])
    }, null, 8, _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: require('@/assets/icons/edit.svg'),
      onClick: _withModifiers($event => $setup.editHandler(data), ["stop"])
    }, null, 8, _hoisted_10), _createElementVNode("img", {
      src: require('@/assets/icons/delete.svg'),
      onClick: _withModifiers($event => $setup.delHandler(node, data), ["stop"])
    }, null, 8, _hoisted_11)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["props", "options", "onChange"])])) : _createCommentVNode("", true)])]), _createVNode(_component_el_aside, {
    style: {
      "background": "#FFF",
      "margin-left": "12px",
      "box-shadow": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_position_detail, {
      detail: $setup.posDetail
    }, null, 8, ["detail"])]),
    _: 1
  })]), _createVNode(_component_el_dialog, {
    title: _ctx.operation === 'add' ? '新增运营位' : '编辑运营位',
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.show = $event),
    width: "700px"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_13, [_createVNode(_component_el_button, {
      size: "small",
      onClick: _cache[10] || (_cache[10] = $event => _ctx.show = false)
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: $setup.confirmHandler
    }, {
      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      size: "small",
      inline: true,
      "label-position": "right",
      "label-width": "100px",
      model: _ctx.formData,
      ref: "form",
      rules: _ctx.rules,
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            "label-width": "",
            prop: "nodeName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.nodeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.formData.nodeName = $event),
              placeholder: "请输入运营位名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "点位类型",
            prop: "positionType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _ctx.formData.positionType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.formData.positionType = $event),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                value: 1,
                label: "节点"
              }), _createVNode(_component_el_option, {
                value: 2,
                label: "运营位"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _ctx.formData.positionType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "素材类型",
            prop: "srcTyp"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _ctx.formData.srcTyp,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.srcTyp = $event),
              style: {
                "width": "100%"
              },
              onChange: $setup.changeSrcTyp
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.srcSuffix, i => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: i.num,
                  value: i.num,
                  label: i.typ
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_ctx.formData.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "点位规格",
            prop: "picSize"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.picSize,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.formData.picSize = $event),
              placeholder: "尺寸限制(px) 如：100*100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), !(_ctx.formData.srcTyp == '4' || _ctx.formData.srcTyp == '7') ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "后缀"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.srcTypSuffix,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.formData.srcTypSuffix = $event),
              disabled: true
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文件大小",
            prop: "picFileSize"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.picFileSize,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.formData.picFileSize = $event),
              placeholder: "可配置最大文件(kb)"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "排序",
            prop: "sortNumber"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.sortNumber,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.formData.sortNumber = $event),
              placeholder: "请输入序号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "描述"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.nodeDesc,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.formData.nodeDesc = $event),
              placeholder: "点位描述"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _ctx.formData.status,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.formData.status = $event),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                value: 0,
                label: "禁用"
              }), _createVNode(_component_el_option, {
                value: 1,
                label: "启用"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "外部渠道码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.formData.sysChannel,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.formData.sysChannel = $event),
              placeholder: "请输入外部渠道码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["title", "modelValue"])], 64);
}